import React from 'react'
import styles from './SimpleNavPanel.module.sass'
import { MenuItemType } from '@utils/types'
import { WLink } from '@components/atoms'

interface Props {
  className?: string
  item?: MenuItemType
}

const SimpleNavPanel = (props: Props) => {
  const { className = '', item = undefined } = props

  return (
    <div className={`${styles.root} ${className}`} key={item.pk}>
      {(!!item.children.length || (!!item.ctaLabel && !!item.url)) && (
        <ul className={styles.list}>
          {item.children.map((x, index) => (
            <li key={x.pk} className={styles.item}>
              <WLink href={x.url} newPage={x.blank}>
                {x.name}
              </WLink>
            </li>
          ))}
          {!!item.ctaLabel && !!item.url && (
            <li className={styles.item}>
              <WLink href={item.url} newPage={item.blank}>
                {item.ctaLabel}
              </WLink>
            </li>
          )}
        </ul>
      )}
    </div>
  )
}

export default SimpleNavPanel
